
<div>
  <field-item
    v-for="field in section.fields"
    :key="field.id"
    :disabled="handler.isDisabled(field, parentTreeContext)"
    @click="select(section.select(field, ...selectAdditionalParameters))"
  >
    <row>
      <prefix>
        <icon :glyph="iconGlyph"/>
      </prefix>
      <column>
        {{field.label}}
      </column>
    </row>
  </field-item>
</div>
